import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'redux-form';
import HiddenLearningAssetsTable from './HiddenLearningAssetsTable';

export default class HiddenLearningAssetsSection extends PureComponent {
    static propTypes = {
        hiddenLearningAssetOptions: PropTypes.arrayOf(PropTypes.object),
        loggedInUser: PropTypes.object,
        currentValues: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.state = {
            selectedHiddenLearningAsset: {}
        };
    }

    handleHiddenLearningAssetChange = (selectedLearningAsset) => {
        this.setState({ selectedHiddenLearningAsset: selectedLearningAsset });
    };

    handleAddHiddenLearningAsset = (fields, asset = {}) => {
        const { loggedInUser } = this.props;

        if (asset && asset._id) {
            fields.push({
                id: asset._id,
                name: asset.name,
                selectedDateTime: new Date(),
                selectedBy: {
                    userProfileId: loggedInUser._id,
                }
            });

            this.setState({ selectedHiddenLearningAsset: {} });
        }
    };

    render() {
        const { hiddenLearningAssetOptions, currentValues } = this.props;
        const { selectedHiddenLearningAsset } = this.state;
        return (
            <div className={'hidden-learning-assets-section'}>
                <FieldArray
                    name={'hiddenLearningAssets'}
                    selectedHiddenLearningAsset={selectedHiddenLearningAsset}
                    hiddenLearningAssetOptions={hiddenLearningAssetOptions}
                    handleHiddenLearningAssetChange={this.handleHiddenLearningAssetChange}
                    handleAddHiddenLearningAsset={this.handleAddHiddenLearningAsset}
                    currentValues={currentValues}
                    component={HiddenLearningAssetsTable}
                />
            </div>
        );
    }
}
